export const environment = {
  production: true,
  type: 'production',
  api_url: 'https://bubba.wibodev.com',
  api_admin_url: 'https://bubba-dashboard-admin-prod.wibodev.com',
  auth_token_key: 'auth-totem',
  url_pwa: 'pidecondary.com',
  site_id: '', //Este campo debe ser generado cada vez que se cree una pwa
  version: '2.6.1',
  support: {
    type: 'chat',
    url: 'https://ayuda.holadary.com/',
  },
  firebase: {
    apiKey: 'AIzaSyAGnNKGYV8fFx2gfUKn6uer09BgiVAZH1U',
    authDomain: 'wibo-hosting-v1.firebaseapp.com',
    databaseURL: 'https://wibo-hosting-v1.firebaseio.com',
    projectId: 'wibo-hosting-v1',
    storageBucket: 'wibo-hosting-v1.firebasestorage.app',
    messagingSenderId: '663205824094',
    appId: '1:663205824094:web:af66805da3976829ce96cf',
    measurementId: 'G-F2XLP2HWJP',
  },
};
